import React, { useEffect, useState } from "react";

import TaskStatus from "../../task-status";

import { getTasksByContextKey } from "../../task-list/lib/taskData";
import { SourcePage } from "shared/taskTypeMap";

const StatusItem = ({ product }) => {
    const [tasks, setTasks] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const data = await getTasksByContextKey(product.key);

            if (!data) {
                return;
            }

            setTasks(data);
        };
        fetchData();
    }, []);

    return (
        <div className="status-item">
            <TaskStatus tasks={tasks} isFinalized={true} sourcePage={SourcePage["finalqa.standard"]} />
        </div>
    );
};

export default StatusItem;
